module.exports = __webpack_public_path__ + "static/bottom-26b2d281facc1c1b7dc662b551b77eb4.png";